var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ローディング
import {
    loading
} from "../include/module";
loading();

//ヘッダーの開閉
import {
    headerToggle
} from "../include/module";
headerToggle();

//ページ内リンクのアニメーション
import {
    anchorScroll
} from "../include/module";
anchorScroll();

// preload
import {
    preload
} from "../include/module";
preload();

// resizing
import {
    resizing
} from "../include/module";
resizing();

// アニメーション
import {
    animationFire
} from "../include/module";
animationFire();

//タブ切り替え
const bd_Tab = () => {
    const $tabNav = $('.bd-Tab').find('li');
    const $st_Wrapper = $('.st-Wrapper');
    $tabNav.on('click', function () {
        $($tabNav).removeClass('current');
        let element = this.className;
        $(this).addClass('current');
        if (element == 'season1') {
            $($st_Wrapper).addClass('season1');
            $($st_Wrapper).removeClass('season2');
            $($st_Wrapper).removeClass('season3');
        } else if (element == 'season2') {
            $($st_Wrapper).addClass('season2');
            $($st_Wrapper).removeClass('season1');
            $($st_Wrapper).removeClass('season3');
        } else if (element == 'season3') {
            $($st_Wrapper).addClass('season3');
            $($st_Wrapper).removeClass('season1');
            $($st_Wrapper).removeClass('season2');
        }
    });
    
    var hash = location.hash;
    let tabname = hash.slice(1);
    let tabname2 = hash.slice(7);
    let s1 = document.getElementById('season1');
    let s2 = document.getElementById('season2');
    let s3 = document.getElementById('season3');
    hash = (hash.match(/^#season\d+$/) || [])[0];
    if ($(hash).length) {
        if (tabname2 == '1') {
            if ((s2 == null) || (s3 == null)) {
                $('.bd-Tab li').eq(1).addClass('current');
            } else {
                $('.bd-Tab li').eq(2).addClass('current');
            }
            $($st_Wrapper).removeClass('season3 season2');
            $($st_Wrapper).addClass('season1');
        } else if (tabname2 == '2') {
            if (s3 == null) {
                $('.bd-Tab li').eq(0).addClass('current');
                // }else if (s1 == null){
                //   $('.bd-Tab li').eq(1).addClass('current');
            } else {
                $('.bd-Tab li').eq(1).addClass('current');
            }
            $($st_Wrapper).removeClass('season3 season1');
            $($st_Wrapper).addClass('season2');
        } else if (tabname2 == '3') {
            $('.bd-Tab li').eq(0).addClass('current');
            $($st_Wrapper).removeClass('season2 season1');
            $($st_Wrapper).addClass('season3');
        }
        // $('.bd-Tab li').eq(tabname2).addClass('current');
        // $($st_Wrapper).toggleClass(tabname);
    } else {
        $('.bd-Tab li').eq(0).addClass('current');
        // $($st_Wrapper).toggleClass('season3');
    }
};
bd_Tab();


// WEBPACK FOOTER //
// ./src/assets/js/bd-box/script.js